import { TypeDefinitions } from './definition.js';
import { Details } from './details.js';
import * as RuleMethods from './methods/rule.js';
import { Props } from './props.js';
import { isTypeInCategory } from './definition.js';
export function RuleConstructor({ type, details, props }) {
    return {
        type,
        details: Details({
            exampleContent: type === 'text' || type === 'typography' ? 'Example' : null,
            ...details,
            title: type == 'font' && !(details === null || details === void 0 ? void 0 : details.title) ? props === null || props === void 0 ? void 0 : props.familyName : (details === null || details === void 0 ? void 0 : details.title) || ''
        }),
        props: TypeDefinitions[type] ? TypeDefinitions[type].Props(props) : props
    };
}
export const RuleShortcuts = {
    fix(style, rules) {
        var { type, details, props } = style;
        return Rule({
            type,
            details: {
                ...details,
                slug: details.slug || Rule.getSlug(style, rules)
            },
            props: Props.fix(type, props, rules)
        });
    },
    /** Ensure that basic shape of a style is correct  */
    isValid(rule) {
        return rule.type && rule.details.title && rule.details.id && rule.props;
    },
    isInCategory(style, category) {
        return isTypeInCategory(style.type, category);
    },
    /** A constructor for newly created rules for a given collection. Assigns some default values */
    forCollection(collection) {
        const style = RuleConstructor({
            type: collection.props.type,
            details: {
                collectionId: collection.details.id
            }
        });
        if (style.type === 'color') {
            style.props = { red: 255, green: 255, blue: 255, alpha: 1 };
        }
        if (style.type === 'text' || style.type === 'inline' || style.type === 'block') {
            // @ts-ignore
            style.props = Object.keys(style.props).reduce((acc, prop) => {
                return { ...acc, [prop]: ['blank-' + prop.replace('Ids', '')] };
            }, {});
        }
        return style;
    }
};
export const Rule = Object.assign(RuleConstructor, RuleMethods, RuleShortcuts);
//# sourceMappingURL=rule.js.map